import { ImplementorTemplateParams } from "components/stories/video-studio/utils/creatomate/setCustomTemplate";
import deleteElement from "components/stories/video-studio/utils/creatomate/deleteElement";
import syncMediaElements from "components/stories/video-studio/utils/creatomate/syncMediaElements";
import { ELEMENT_NAMES } from "components/stories/video-studio/utils/constants";
import { cacheAssetIfNeeded, calculateVideoDuration } from "../../utils/utils";
import findElementByName from "../../utils/findElementByName";

const movingCirclesInBackgroundWithNameAndTitlePremiseTemplate = async ({
  preview,
  mediaElements,
  defaultVideoProperties,
  story
}: ImplementorTemplateParams) => {
  cacheAssetIfNeeded(preview, story);

  const json = preview.getSource();
  const elements = json?.elements;

  const storyVideoElement = findElementByName(elements, ELEMENT_NAMES.STORY);
  const topCircleElement = findElementByName(elements, ELEMENT_NAMES.TOP_CIRCLE);
  const bottomCircleElement = findElementByName(elements, ELEMENT_NAMES.BOTTOM_CIRCLE);
  const titleUnderlineElement = findElementByName(elements, ELEMENT_NAMES.TITLE_UNDERLINE);
  const titleElement = findElementByName(elements, ELEMENT_NAMES.TITLE);
  const nameElement = findElementByName(elements, ELEMENT_NAMES.NAME);
  const primaryGradientElement = findElementByName(elements, ELEMENT_NAMES.PRIMARY_GRADIENT);

  const TITLE_START_TIME = titleElement?.time ?? 0;
  const TITLE_UNDERLINE_START_TIME = titleUnderlineElement?.time ?? 0;

  await syncMediaElements(preview, mediaElements, {
    ...defaultVideoProperties,
    track: storyVideoElement?.track,
    y: storyVideoElement?.y,
    width: storyVideoElement?.width,
    height: storyVideoElement?.height,
    border_radius: storyVideoElement?.border_radius,
    clip: storyVideoElement?.clip
  }, 0);
  await deleteElement(preview, storyVideoElement?.id);
  const videoDuration = calculateVideoDuration(mediaElements);
  await preview.applyModifications({
    [`${nameElement?.id}.text`]: story?.creator?.name,
    [`${titleElement?.id}.text`]: story?.creator?.title || "",
    [`${nameElement?.id}.duration`]: videoDuration,
    [`${primaryGradientElement?.id}.duration`]: videoDuration,
    [`${titleElement?.id}.duration`]: videoDuration - TITLE_START_TIME,
    [`${topCircleElement?.id}.duration`]: videoDuration,
    [`${bottomCircleElement?.id}.duration`]: videoDuration,
    [`${titleUnderlineElement?.id}.duration`]: videoDuration - TITLE_UNDERLINE_START_TIME,
    duration: videoDuration
  });
};

export default movingCirclesInBackgroundWithNameAndTitlePremiseTemplate;
